import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {Row, Col} from 'react-bootstrap';
import { Redirect } from 'react-router-dom';

import LanguageSelect from 'containers/ui/select/LanguageSelect';
import LoginFormContainer from 'containers/login/LoginFormContainer';
import Footer from 'components/ui/layout/Footer.jsx';

import {changeTitle} from 'modules/ui';

import 'style/routes/login.scss';

const logoUrl = require('img/equinix_logo.svg');

/** The Login page */
class Login extends Component {

    componentDidMount() {
        const {
            dispatch,
            intl: {formatMessage}
        } = this.props;

        dispatch(changeTitle(formatMessage({id: 'title.sign_in'})));
    }

    render() {
        const
            {location: {state}, auth} = this.props,
            nextPathName = state ? state.nextPathname : null;

        if (auth.isLoggedIn) {
            return (
                <Redirect to={{pathname: '/'}} />
            );
        }

        return (
            <div>
                <div className="container login-container">
                    <Row>
                        <Col sm={4}>
                            <div className="login-logo">
                                <img alt="logo2" src={logoUrl}/>
                            </div>
                        </Col>
                        <Col sm={6} lg={5}>
                            <LanguageSelect className="pull-right"/>
                            <LoginFormContainer nextPathname={nextPathName} />
                        </Col>
                    </Row>
                </div>
                <div>
                    <Footer />
                </div>
            </div>

        );
    }
}

const mapStateToProps = state => ({
    auth: state.auth
});

export default injectIntl(connect(mapStateToProps)(Login));



// WEBPACK FOOTER //
// ./src/routes/Login.jsx